import { TDeviceType } from '@cian/ui-kit';
import { getSiteType } from '../getSiteType';
import { IProduct } from '../../types/analytics';
import { ca } from '@cian/analytics';

interface ITrackPageLoad {
  deviceType: TDeviceType;
  userId: number | null;
  products: IProduct[];
}

export const trackPageLoad = ({ deviceType, userId, products }: ITrackPageLoad) => {
  ca('event', {
    category: 'seen_label',
    action: 'show_sopr',
    name: 'oldevent',
    page: {
      pageType: 'Recommendations',
      siteType: getSiteType(deviceType),
    },
    user: userId ? { userId } : {},
    products,
  });
};
